// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"490":"40ae5c864fee1354","759":"1555acb0f31a99b4","859":"8766237c7c50c7cb"}[chunkId] + ".js";
};